'use client'

import { useEffect, useState } from 'react'
import posthog from 'posthog-js'
import { isChunkLoadError, recoverFromChunkError } from './chunk-reload'

/**
 * Shared behaviour for error boundaries: reload once for a chunk failure,
 * otherwise report the error. Returns true while a reload is in flight so the
 * boundary can render nothing instead of flashing an error card.
 *
 * Recovered errors are still captured (tagged) so a CDN or deploy problem
 * remains visible in PostHog even when users never see it. posthog-js flushes
 * its queue via sendBeacon on pagehide, so the capture survives the reload.
 */
export function useChunkRecovery(error: Error & { digest?: string }): boolean {
  const [recovering, setRecovering] = useState(() => isChunkLoadError(error))

  useEffect(() => {
    if (recoverFromChunkError(error)) {
      posthog.captureException(error, { chunk_reload: true })
      return
    }
    setRecovering(false)
    posthog.captureException(error)
  }, [error])

  return recovering
}
